/* eslint-disable import/prefer-default-export */
import { variant1, variant2 } from './constants';
/**
 * Stores a variety of props which change value depending on what site the user is on
 *
 *  @returns {object} - Returns an object containing the prop values based on the variant
 * @param variant
 */
export const useConfiguration = (variant) => {
    let backCtaColor;
    let backIconColor;
    let accessoryTitlePb;
    let iconWrapperMarginTop = '-3px';
    switch (variant) {
        // HONDA_SITE_NAME
        case variant1:
            iconWrapperMarginTop = '-1px';
            backCtaColor = 'black';
            backIconColor = 'red';
            accessoryTitlePb = ['0px', '0px', '6px'];
            break;
        // ACURA_SITE_NAME
        case variant2:
            backCtaColor = 'blue';
            backIconColor = 'blue';
            accessoryTitlePb = ['0px', '0px', '4px'];
            break;
        default:
            backCtaColor = 'blue';
            backIconColor = 'blue';
            accessoryTitlePb = [];
            break;
    }
    return {
        backCtaColor,
        backIconColor,
        accessoryTitlePb,
        iconWrapperMarginTop,
    };
};
export const getOtherColors = ({ allTransmissions, transmissionKey, exteriorColorKey, }) => {
    var _a, _b, _c, _d, _e;
    const colorKeysCurrentTransmission = ((_b = (_a = allTransmissions === null || allTransmissions === void 0 ? void 0 : allTransmissions.find(c => (c === null || c === void 0 ? void 0 : c.transmissionKey) === transmissionKey)) === null || _a === void 0 ? void 0 : _a.exteriorColors) === null || _b === void 0 ? void 0 : _b.map(i => i.key)) || [];
    const allOtherColors = (_e = (_d = (_c = allTransmissions === null || allTransmissions === void 0 ? void 0 : allTransmissions.filter(c => (c === null || c === void 0 ? void 0 : c.transmissionKey) !== transmissionKey)) === null || _c === void 0 ? void 0 : _c.map(i => { var _a; return (_a = i === null || i === void 0 ? void 0 : i.exteriorColors) === null || _a === void 0 ? void 0 : _a.filter(c => (c === null || c === void 0 ? void 0 : c.key) !== exteriorColorKey); })) === null || _d === void 0 ? void 0 : _d.flat()) === null || _e === void 0 ? void 0 : _e.filter(x => (x === null || x === void 0 ? void 0 : x.key) && !colorKeysCurrentTransmission.includes(x.key));
    const otherColorsUniqKeys = new Set(allOtherColors.map(i => i === null || i === void 0 ? void 0 : i.key));
    const otherColors = Array.from(otherColorsUniqKeys).map(i => allOtherColors.find(c => (c === null || c === void 0 ? void 0 : c.key) === i));
    return otherColors || [];
};
export const getProtectionPrice = (defaultAmount, terms, termAndRate) => {
    var _a, _b;
    if (termAndRate && terms) {
        return (_b = (_a = terms.find((term) => term.term === termAndRate)) === null || _a === void 0 ? void 0 : _a.amount) !== null && _b !== void 0 ? _b : defaultAmount;
    }
    return defaultAmount;
};
